import { API_ROUTES, HTTP_METHODS, PAGE_SIZE } from '@Utils/constants';
import { sendCall } from '@Utils/request.utils';

const { ASSET } = API_ROUTES;

class AssetService {
  createAsset = (params: unknown) =>
    sendCall(ASSET.POST, {
      data: params,
      method: HTTP_METHODS.POST,
    });

  getAsset = (id: string | undefined) => sendCall(`${ASSET.GET}/${id}`, { method: HTTP_METHODS.GET });

  getAssets = (page: number | null, pagination: boolean) =>
    sendCall(`${ASSET.GET}?page=${page}&limit=${PAGE_SIZE}&pagination=${pagination}`, {
      method: HTTP_METHODS.GET,
    });

  getSpecificAsset = (id: string | undefined) => sendCall(`${ASSET.GET}/${id}`, { method: HTTP_METHODS.GET });

  getAssetsSearch = (params: unknown, page: number) =>
    sendCall(`${ASSET.SEARCH_POST}?page=${page}&limit=${PAGE_SIZE}`, {
      data: params,
      method: HTTP_METHODS.POST,
    });

  editAsset = (id: string | undefined, params: unknown) =>
    sendCall(`${ASSET.EDIT}/${id}`, { data: params, method: HTTP_METHODS.POST });

  assignAsset = (id: string | undefined, params: unknown) =>
    sendCall(`${ASSET.PUT}/${id}`, { data: params, method: HTTP_METHODS.PUT });

  unassignAsset = (id: string | undefined, params: unknown) =>
    sendCall(`${ASSET.UNASSIGN}/${id}`, { data: params, method: HTTP_METHODS.PUT });

  uploadAsset = (params: unknown) =>
    sendCall(ASSET.UPLOAD, {
      data: params,
      method: HTTP_METHODS.POST,
    });
}

export default new AssetService();
